import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const values = [
  { icon: 'ri-checkbox-circle-line', title: 'Accountability', desc: 'ensuring transparency in operations, including financial propriety and environmental sustainability. E. Protection of Beneficiaries: prohibiting all forms of exploitation and abuse, and ensuring that child safety is paramount.' },
  { icon: 'ri-shield-check-line', title: 'Safeguarding', desc: 'A commitment to safety, dignity, and preventing harm, with mandatory reporting of concerns within 24 hours. A zero tolerance policy exists for any form of exploitation, abuse, or harm, particularly toward children and vulnerable adults.' },
  { icon: 'ri-group-line', title: 'Respect and Equality', desc: 'commitment to non-discrimination, treating all individuals with dignity regardless of race, gender, religion, or background.' },
  { icon: 'ri-hand-heart-line', title: 'Protection and Advocacy', desc: 'we are committed to support people in restoring relationships and forming safe and secure communities. We prioritize the protection of all-especially children and at-risk adults from physical, social and psychological harm. We assess risks and seek to act in ways that minimize people\'s exposure to danger or abuse.' },
  { icon: 'ri-women-line', title: 'Gender Justice', desc: 'We promote equal opportunities and rights for all genders, addressing systemic inequalities and empowering women and girls.' },
  { icon: 'ri-leaf-line', title: 'Environmental Stewardship', desc: 'commitment to sustainability and minimizing negative impacts on the environment.' },
  { icon: 'ri-medal-line', title: 'Ethical Behavior', desc: 'promotion of trust, respect, and non-discrimination, ensuring actions do not abuse power or trust. C. Christian values: encouragement of humility, compassion, and servant-heartedness, often including a commitment to prayer and alignment with their statement of faith.' },
  { icon: 'ri-seedling-line', title: 'Empowerment', desc: 'We are committed to community-led, participatory approaches to development and humanitarian response for sustainable impact, based on root cause analysis.' },
  { icon: 'ri-global-line', title: 'Sustainability', desc: 'Our programs focus on long-term, sustainable impact for generations to come.' },
  { icon: 'ri-hands-heart-line', title: 'Compassion', desc: 'encouragement of humility, compassion, and servant-heartedness' },
];

const team = [
  {
    name: 'DEO MANEGABE MUDA',
    role: 'Executive Director',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/ceo_vjdsa4.jpg',
  },
  {
    name: 'Naome Precious Nalugo',
    role: 'Finance Manager',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/financial_p9esyx.jpg',
  },
 
  {
    name: 'Merveille Akonkwa',
    role: 'Deputy Director',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301170/deputy_txpssy.jpg',
  },
  {
    name: 'Anyole Muyeme Daniel',
    role: 'ICT & Media Manager',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301172/pro.mngr_rcs4ny.jpg',
  },
  {
    name: 'Jordan Saint Bisimwa Buroko',
    role: 'Outreach Manager',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774313861/OUTREACH_pbwud2.jpg',
  },
  {
    name: 'Awad Bimba Mibaraka King',
    role: 'Fund raiser',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301172/funderser_ynvcjz.jpg',
  },
  {
    name: 'Benedicte Ayagirwe ',
    role: 'MEAL',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/meal_i49qjo.jpg',
  },
   {
    name: 'Gedeon Bisimwa Christian',
    role: 'Program Supervisor',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/prog.supr_ctyfqi.jpg',
  },
  {
    name: 'Bayubasire Mugomoka Blaise',
    role: 'Accountant',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301170/bd796ea8-4436-4fe3-b5ae-5b52d21dd16a_gbyogj.jpg',
  },
  {
    name: 'Josephine Mawazo Masonga ',
    role: 'Advisor',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/health_iimb04.jpg',
  },
  {
    name: 'Divine NSHOBOLE',
    role: 'Supervisor',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/super_qim331.jpg',
  },
   
];

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Page Hero */}
      <section className="relative h-[50vh] min-h-[360px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774853562/top-about2_qutvxn.jpg"
            alt="About El Hai"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#003366]/75" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <nav className="text-sm mb-4">
            <Link to="/" className="text-[#ADD8E6] hover:underline cursor-pointer">Home</Link>
            <span className="text-white/50 mx-2">&rsaquo;</span>
            <span className="text-white">About Us</span>
          </nav>
          <h1 className="text-4xl sm:text-5xl font-bold text-white">About El Hai Ministries</h1>
          <p className="text-[#ADD8E6] mt-3 text-lg">'Hands to serve , Hearts to care </p>
        </div>
      </section>

      <main>
        {/* Our Story */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              <div>
                <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Our Story</span>
                <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-6">
                  Building Communities Since 2024
                </h2>
                <p className="text-gray-500 text-base leading-relaxed mb-5">
                  El Hai Pentecostal Ministries was founded in 2024 in zana, Uganda, with a simple yet powerful vision: to use faith as a foundation for transforming communities. What started as a small congregation committed to serving the marginalized has grown into a recognized NGO impacting thousands of lives.
                </p>
                <p className="text-gray-500 text-base leading-relaxed mb-5">
                  Over the years, we have developed a suite of community programs that address root causes of poverty — providing economic opportunities through Financial Inclusion, building skills through vocational and ICT Training, promoting food security, and ensuring the elderly and disabled receive dignified care.
                </p>
                <p className="text-gray-500 text-base leading-relaxed">
                  Our approach is holistic: we believe that true transformation comes when spiritual, economic, educational, and physical needs are met together. We partner with local leaders, international donors, churches, and government agencies to multiply our impact.
                </p>
              </div>
              <div className="rounded-xl overflow-hidden h-80 lg:h-[420px]">
                <img
                  src="https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775093596/ChatGPT_Image_Apr_2_2026_04_32_07_AM_tspoeh.png"
                  alt="Our Story"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Mission & Vision</h2>
              <p className="text-gray-500 max-w-xl mx-auto">
                Our direction is guided by a clear mission and an ambitious vision for the communities we serve.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-[#003366] text-white rounded-xl p-10">
                <div className="w-14 h-14 flex items-center justify-center bg-[#ADD8E6]/20 rounded-xl mb-6">
                  <i className="ri-focus-3-line text-3xl text-[#ADD8E6]" />
                </div>
                <h3 className="text-xl font-bold text-[#ADD8E6] uppercase tracking-wide mb-4">Our Mission</h3>
                <p className="text-white/80 text-base leading-relaxed">
                  To respond to refugees and hosts in need by best learning opportunities and livelihood activities through new transformations , methods and technologies , community-centered programs that promote honor , autonomy and long-term development.
                </p>
              </div>
              <div className="bg-[#ADD8E6] rounded-xl p-10">
                <div className="w-14 h-14 flex items-center justify-center bg-[#003366]/10 rounded-xl mb-6">
                  <i className="ri-eye-line text-3xl text-[#003366]" />
                </div>
                <h3 className="text-xl font-bold text-[#003366] uppercase tracking-wide mb-4">Our Vision</h3>
                <p className="text-[#003366]/80 text-base leading-relaxed">
                  A space where refugees and hosts in need have access to best quality lifelong learning and livelihood opportunities streamlining them to live transformed lives and improve societal well-being.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Goal */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Our Target</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Our Goal</h2>
            </div>
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-gray-600 text-lg leading-relaxed">
                To empower refugees and hosts in need by guaranteed resources that provide best lifelong learning and livelihood opportunities.
              </p>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">What Guides Us</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Our Core Values</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {values.map((v) => (
                <div key={v.title} className="text-center p-8 rounded-xl bg-[#F8F8F8] hover:-translate-y-1 transition-transform duration-200">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#ADD8E6]/30 rounded-full">
                    <i className={`${v.icon} text-2xl text-[#003366]`} />
                  </div>
                  <h4 className="font-bold text-[#003366] text-lg mb-2">{v.title}</h4>
                  <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Leadership</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Meet Our Team</h2>
              <p className="text-gray-500 max-w-lg mx-auto">
                Dedicated leaders committed to transforming communities through compassionate service and faith.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {team.map((member) => (
                <div key={member.name} className="text-center">
                  <div className="w-28 h-28 mx-auto rounded-full overflow-hidden mb-4 border-4 border-[#ADD8E6]">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h4 className="font-bold text-[#003366] text-base">{member.name}</h4>
                  <p className="text-[#ADD8E6] text-sm mt-1">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#003366] py-16 text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-white mb-4">Be Part of Our Story</h2>
            <p className="text-white/70 mb-8 text-base">Join thousands of people who believe in the power of community and faith to transform lives.</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/donate" className="px-8 py-3 bg-[#ADD8E6] text-[#003366] font-bold rounded-lg hover:bg-white transition-colors cursor-pointer whitespace-nowrap">
                Donate Now
              </Link>
              <Link to="/contact" className="px-8 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-[#003366] transition-colors cursor-pointer whitespace-nowrap">
                Join Us
              </Link>
            </div>
          </div>
        </section>

        {/* Organizational Structure */}
<section className="bg-white py-20">
  <div className="max-w-5xl mx-auto px-4 text-center">
    <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">
      Organization
    </span>

    <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-4">
      Our Organizational Structure
    </h2>

    <p className="text-gray-500 mb-8 max-w-2xl mx-auto">
      View our official organizational structure to understand leadership roles, departments, and reporting lines.
    </p>

    {/* Buttons */}
    <div className="flex flex-wrap justify-center gap-4">
      
      {/* View PDF */}
      <a
        href="/assets/structural.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 py-3 bg-[#003366] text-white font-semibold rounded-lg hover:bg-[#002244] transition"
      >
        View Structure
      </a>

      {/* Download PDF */}
      <a
        href="/assets/structural.pdf"
        download
        className="px-6 py-3 bg-[#ADD8E6] text-[#003366] font-semibold rounded-lg hover:bg-white border border-[#ADD8E6] transition"
      >
        Download PDF
      </a>

    </div>
  </div>
</section>
      </main>

      <Footer />
    </div>
  );
}
